import {takeLatest, call, put} from "redux-saga/effects";
import {getSims, createSim} from "../AsyncActions/sim.async";
import * as actions from "../action.constants";
import {
  deleteSim,
  editSim,
  simUsage,
  suspendSim,
  activateSim,
  deactivateSim,
} from "../AsyncActions/sim.async";
import {
  saveSimUsageDetails,
  updateAddsimModal,
  updateAddsimModalData,
} from "../Actions/sims.actions";

function* simRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getSims, pageUrl);
    if (response) {
      yield put({type: actions.SAVE_SIMS_LIST, responsePayload: response?.data});
    }
  } catch (e) {
    // console.log("error", e);
  }
}

function* handleSimModalResponse() {
  yield put(updateAddsimModal(false));
  yield put(updateAddsimModalData({}));
}

function* createSimRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;
  try {
    const response = yield call(createSim, payload);
    if (response) {
      yield callback();
      yield call(handleSimModalResponse);
    }
  } catch (e) {
    // console.log("error", e);
  }
}

function* editSimRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(editSim, payload);
    if (response) {
      yield callback();
      yield call(handleSimModalResponse);
    }
  } catch (e) {
    return e;
  }
}

function* deleteSimRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(deleteSim, payload);
    if (response) {
      yield callback();
    }
  } catch (e) {
    return e;
  }
}

function* suspendSimRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(suspendSim, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* activateSimRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(activateSim, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* deactivateSimRequest(action = {}) {
  const {payload = {}, callback = () => {}} = action;

  try {
    const response = yield call(deactivateSim, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* simUsageRequest(action = {}) {
  const {payload = {}} = action;

  try {
    const response = yield call(simUsage, payload);
    if (response?.data) {
      yield put(saveSimUsageDetails(response?.data?.data));
    }
  } catch (e) {
    return e;
  }
}

export function* simSaga() {
  yield takeLatest(actions.REQUEST_SIMS, simRequest);
  yield takeLatest(actions.REQUEST_SEND_ADD_SIM_DATA_SAGA, createSimRequest);
  yield takeLatest(actions.REQUEST_DELETE_SIM_SAGA, deleteSimRequest);
  yield takeLatest(actions.REQUEST_SUSPEND_SIM_SAGA, suspendSimRequest);
  yield takeLatest(actions.REQUEST_ACTIVATE_SIM_SAGA, activateSimRequest);
  yield takeLatest(actions.REQUEST_DEACTIVATE_SIM_SAGA, deactivateSimRequest);
  yield takeLatest(actions.REQUEST_SEND_EDIT_SIM_DATA_SAGA, editSimRequest);
  yield takeLatest(actions.REQUEST_SIM_USAGE_DETAILS_SAGA, simUsageRequest);
}
